// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.stop-all_stop-all_kLygy {
  width: 2rem;
  height: 2rem;
  padding: 0.375rem;
  border-radius: 0.25rem;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  cursor: pointer;
}

.stop-all_stop-all_kLygy:hover {
  background-color: var(--looks-light-transparent);
}

.stop-all_stop-all_kLygy {
  opacity: 0.5;
}

.stop-all_stop-all_kLygy.stop-all_is-active_vUUE6 {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/stop-all/stop-all.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.stop-all {\n  width: 2rem;\n  height: 2rem;\n  padding: 0.375rem;\n  border-radius: 0.25rem;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer;\n}\n\n.stop-all:hover {\n  background-color: var(--looks-light-transparent);\n}\n\n.stop-all {\n  opacity: 0.5;\n}\n\n.stop-all.is-active {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stop-all": `stop-all_stop-all_kLygy`,
	"stopAll": `stop-all_stop-all_kLygy`,
	"is-active": `stop-all_is-active_vUUE6`,
	"isActive": `stop-all_is-active_vUUE6`
};
export default ___CSS_LOADER_EXPORT___;
